import { AuthServiceBase } from "@js/filesfromccqbase/AuthServiceBase";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import { RoleService } from "./RoleService";
import { ApplicationUser, ApplicationUserCrudClient, StaticDataClient, UserClient } from "@src/apis/ModularClient";
import { IndexService } from "@js/services/IndexService";

export class AuthService extends AuthServiceBase<ApplicationUser> {
  isValidStatus: boolean;

  static $inject = [
    "$http",
    "$cookies",
    "$rootScope",
    "$q",
    "$timeout",
    "$httpParamSerializerJQLike",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "StaticDataClient",
    "BroadcastService",
    "$location",
    "RoleService",
  ];

  isLoggedIn: boolean = false;
  configSettings: { [key: string]: string }[];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    httpParamSerializerJQLike: ng.IHttpParamSerializer,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    staticDataClient: StaticDataClient,
    private $broadcastservice: BroadcastService,
    private $location: ng.ILocationService,
    protected roleService: RoleService,
  ) {
    super(
      http,
      cookies,
      rootScope,
      q,
      timeout,
      httpParamSerializerJQLike,
      userClient,
      applicationUserCrudClient,
      indexService,
      staticDataClient,
    );
  }

  logout(callLogin: boolean = true) {
    //TODO:CHECK THIS possibly meant to be?? this.$cookies.remove("token");
    delete (this.$cookies as any).token;
    delete (this.$cookies as any).loggedUser;
    delete (this.$cookies as any).loggedUserID;
    delete (this.$cookies as any).tokenValidTo;
    delete (this.$cookies as any).access_token;
    this.isLoggedIn = false;
    (this.$rootScope as any).selectedUser = null;
    (this.$rootScope as any).loanCriteria = null; //reset the loancriteria
    (this.$rootScope as any).currentUser = null;
    this.roleService.resetUserRoles(); //clear user roles
    super.logout();
    sessionStorage.clear();
    if (callLogin) {
      this.$location.path("#!/login");
    }
  }

  getIsLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  setIsLoggedIn(isLoggedIn: boolean) {
    this.isLoggedIn = isLoggedIn;
  }

  clearStorageData() {
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("userDetails");
    sessionStorage.removeItem("assignUserToOrg");
    sessionStorage.removeItem("isUpgradedUser");
    sessionStorage.removeItem("skip");
    sessionStorage.removeItem("projectname");
    sessionStorage.removeItem("selectedPackage");
    sessionStorage.removeItem("returningFromdeletedSearch");
    sessionStorage.removeItem("addAddon");
    sessionStorage.removeItem("selectedProduct");
    sessionStorage.removeItem("searchuser");
    sessionStorage.removeItem("clientId");
    sessionStorage.removeItem("lenderTask");
    sessionStorage.removeItem("loanCriteria");
    sessionStorage.removeItem("DealClientUniqueRef");
    sessionStorage.removeItem("TempSavedResults");
    sessionStorage.removeItem("SelectedUser");
    sessionStorage.removeItem("UniqueId");
    sessionStorage.removeItem("loanCriteria");
    sessionStorage.removeItem("LoanCriteria");
    sessionStorage.removeItem("ComparisonList");
    sessionStorage.removeItem("previousRoute");
    sessionStorage.removeItem("lenderReferralReference");
  }

  clearSelectedNavMenuAndFilterStorageData() {
    sessionStorage.removeItem("selectedNavMenu");
    sessionStorage.removeItem("clientCaseNameFilter");
    sessionStorage.removeItem("statusFilter");
    // Clearing a property value which will show confirm a client phone number modal as soon as they register through enterprise journey.
    sessionStorage.removeItem("showConfirmClientPhoneNo");
  }

  getHasValidStatustoShowShareSearchModal() {
    return this.isValidStatus;
  }

  setHasValidStatustoShowShareSearchModal(isValidStatus) {
    this.isValidStatus = isValidStatus;
  }
}
